export enum KategoryEnum {
  NOT_SELECTED,
  PEOPLE,
  INDUSTRY,
}
